



























import AboutMe from "@/components/AboutMe.vue";
import ReadingList from "@/components/ReadingList.vue";
import SkillsAndEducation from "@/components/SkillsAndEducation.vue";
import Vue from "vue";
import Component from "vue-class-component";
import { Getter } from "vuex-class";
@Component({
  components: {AboutMe, SkillsAndEducation, ReadingList}
})
export default class Home extends Vue
{
  @Getter("IsItDark") private _getterIsDark!: boolean;
}
